import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: $theme.sizing.scale800,
    padding: '0 4px'
}))

export const MainContent = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: $theme.sizing.scale800
}))

export const Title = styled('h1', ({ $theme }) => ({
    ...$theme.typography.HeadingMedium,
    margin: 0,
    fontWeight: 700,
    textAlign: 'center'
}))

export const Subtitle = styled('h2', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    margin: 0,
    fontWeight: 300
}))

export const IconContainer = styled('i', ({ $theme }) => ({
    textAlign: 'center'
}))

export const AdvantageLine = styled('div', ({ $theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: $theme.sizing.scale600
}))

export const CheckmarkIcon = styled('i', ({ $theme }) => ({
    color: $theme.colors.primary,
    fontSize: $theme.sizing.scale600
}))
